<template>
  <div class="col-lg-12 featured-tutorial text-start">
    <div class="header-faq">
      <h3 class="mb-0">Featured Tutorials</h3>
    </div>
    <div class="row">
      <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
        <div class="card features-faq product-box">
          <div class="faq-image product-img"><img class="img-fluid" src="../../assets/images/faq/1.jpg" alt="">
            <div class="product-hover">
              <ul>
                <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
                <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
              </ul>
            </div>
          </div>
          <div class="card-body"><router-link to="/knowledgebase/detail">
              <h6> Web Design</h6>
            </router-link>
            <p>A Web Designing course belongs to the field of Computer Science and IT. It enables students to learn
              various techniques.</p>
          </div>
          <div class="card-footer"><span>Jan 10, 2023</span>
            <ul class="pull-right">
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star-o font-primary"></i></li>
              <li><i class="fa fa-star-o font-primary"></i></li>
              <li><i class="fa fa-star-o font-primary"></i></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
        <div class="card features-faq product-box">
          <div class="faq-image product-img"><img class="img-fluid" src="../../assets/images/faq/2.jpg" alt="">
            <div class="product-hover">
              <ul>
                <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
                <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
              </ul>
            </div>
          </div>
          <div class="card-body"><router-link to="/knowledgebase/detail">
              <h6>Web Development</h6>
            </router-link>
            <p>This course is designed to start you on a path toward future studies in web development and design.</p>
          </div>
          <div class="card-footer"><span>Feb 08, 2023</span>
            <ul class="pull-right">
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star-o font-primary"></i></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xl-3 xl-50 col-sm-6 box-col-6">
        <div class="card features-faq product-box">
          <div class="faq-image product-img"><img class="img-fluid" src="../../assets/images/faq/3.jpg" alt="">
            <div class="product-hover">
              <ul>
                <li><router-link to="/knowledgebase/detail"><i class="icon-link"></i></router-link></li>
                <li><router-link to="/knowledgebase/detail"><i class="icon-import"></i></router-link></li>
              </ul>
            </div>
          </div>
          <div class="card-body"><router-link to="/knowledgebase/detail">
              <h6>UI Design</h6>
            </router-link>
            <p>User interface design (UI) is the design for machines and software, such as mobile devices, computers.</p>
          </div>
          <div class="card-footer"><span>Mar 04, 2023</span>
            <ul class="pull-right">
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
              <li><i class="fa fa-star font-primary"></i></li>
            </ul>
          </div>
        </div>
      </div>
      <featured1Page />
      <featured2 />
    </div>
  </div>
</template>
<script>
import featured2 from "./featured2Page.vue"
import featured1Page from "./featured1Page.vue"
export default {
  components: {
    featured2, featured1Page
  }
}
</script>